import { pb } from "@/lib/pocketbase";
import { pbRepository } from "./pocketbase-repository";
import { auth } from "./auth.service";
import type { Test } from "@/types/models";

const repo = pbRepository<Test>("tests");

function normalize(t: Test): Test {
  return {
    ...t,
    date: (t.date ?? "").slice(0, 10),
    periodFrom: t.periodFrom || undefined,
    periodTo: t.periodTo || undefined,
  };
}

export interface TestInput {
  topic: string;
  title?: string;
  date: string;
  periodFrom?: number;
  periodTo?: number;
}

export const testsService = {
  listAll(): Promise<Test[]> {
    return repo.list({ sort: "date", perPage: 500 }).then((l) => l.map(normalize));
  },

  listByTopic(topicId: string): Promise<Test[]> {
    return repo
      .list({ filter: pb.filter("topic = {:t}", { t: topicId }), sort: "date" })
      .then((l) => l.map(normalize));
  },

  create(data: TestInput): Promise<Test> {
    return repo
      .create({
        ...data,
        periodFrom: data.periodFrom ?? null,
        periodTo: data.periodTo ?? null,
        owner: auth.currentUser()?.id,
      } as unknown as Partial<Test>)
      .then(normalize);
  },

  update(id: string, data: Partial<Test>): Promise<Test> {
    return repo.update(id, data).then(normalize);
  },

  remove(id: string): Promise<void> {
    return repo.remove(id);
  },
};
